import React from "react";
import sandClock from "../../assets/icons/sandClock.webp";
import Squares from "../../assets/Squares";
import { useNavigate } from "react-router-dom";
import { FaHandHoldingWater } from "react-icons/fa";
import { FiAlertCircle } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";
import Notification from "../ui-elements/Notification";

const SeasonMainCard = ({
  name,
  initDate,
  endDate,
  number,
  status,
  onClickDeleteSeason,
  totalDocs,
}) => {
  const navigate = useNavigate();

  const handleClickInfo = (e) => {
    e.stopPropagation();
    Notification({
      title: `Temporada ${number} no publicada`,
      text: `${
        status == "hidden"
          ? "Aún no has configurado las fechas e intervalos de bloques ni medicinas"
          : "Aún no terminas de configurar las cantidades de medicina por fecha programada"
      }`,
      type: "Info",
    });
  };

  return (
    <div
      className="flex gap-y-4 flex-col items-center justify-center p-6 border-[1px] border-accent-green font-poppins rounded-xl m-2 shadow-md bg-white hover:cursor-pointer hover:bg-green-50 transition-all hover:scale-105 duration-300 "
      onClick={(e) => navigate(`${number}`)}
    >
      <div className="flex w-full justify-center relative">
        {status != "published" && number >= totalDocs && (
          <div className="flex absolute right-[0px] top-[-10px]">
            <button
              className="rounded-[50%] hover:bg-light-green-50 transition-all duration-100 p-1"
              onClick={(e) => {
                e.stopPropagation();
                onClickDeleteSeason();
              }}
            >
              <MdDeleteOutline className="w-[25px] h-[25px] text-red-400" />
            </button>
          </div>
        )}
        <img src={sandClock} className="w-[100px]" />
      </div>

      <div className="flex flex-col items-center justify-center gap-y-4">
        <div className="flex flex-row items-center justify-center gap-x-2">
          <h2 className="text-dark-green font-bold text-xl ">
            Temporada {number}
          </h2>
          {status != "published" && (
            <span
              className={`flex justify-center p-1 rounded-xl ${
                status == "hidden" ? "bg-red-200" : "bg-amber-300"
              } text-default-gray`}
              onClick={handleClickInfo}
            >
              <FiAlertCircle />
            </span>
          )}
        </div>

        <span className="font-bold text-light-gray  text-sm">
          Inicia:{""}
          {new Date(initDate).toLocaleDateString("es-PE", {
            day: "numeric",
            month: "long",
            timeZone: "America/Lima",
          })}
        </span>

        <div className="bg-light-purple rounded-full px-6 py-4 text-dark-purple font-bold">
          Finaliza:{" "}
          {new Date(endDate).toLocaleDateString("es-PE", {
            day: "numeric",
            month: "long",
            timeZone: "America/Lima",
          })}
        </div>
      </div>
      <button
        className={`w-full bg-dark-green text-lg  flex justify-center rounded-full py-2 px-4 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins `}
        type="submit"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`${number}/bloques`);
        }}
      >
        <span className="flex flex-row items-center gap-x-2">
          <span>Ir a bloques</span>
          <Squares />
        </span>
      </button>
      <button
        className={` ${
          status === "hidden"
            ? "bg-default-gray cursor-not-allowed"
            : "bg-accent-green hover:bg-dark-green cursor-pointer"
        } w-full  text-lg  flex justify-center rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins `}
        type="submit"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`${number}/programa`);
        }}
        disabled={status === "hidden"}
      >
        <span className="flex flex-row items-center gap-x-2">
          <span className="text-wrap">Ver programa</span>
          <FaHandHoldingWater />
        </span>
      </button>
    </div>
  );
};

export default SeasonMainCard;
